import React, { type ReactElement } from 'react';

import MuiTooltip from '@mui/material/Tooltip';

import { TooltipWrapperProps } from './interfaces';

const TooltipWrapper = ({
  disabled = false,
  children,
  tooltipMessage = '',
  tooltipPlacement = 'bottom',
}: TooltipWrapperProps) => {
  if (tooltipMessage.length > 0) {
    return (
      <MuiTooltip
        disableHoverListener={disabled}
        placement={tooltipPlacement}
        title={tooltipMessage}
      >
        {children as ReactElement}
      </MuiTooltip>
    );
  } else {
    return <>{children}</>;
  }
};

export default TooltipWrapper;
